class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartLink2 = document.querySelector('#cart-icon-bubble-new');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    this.checkGiftEligibility();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      var sectionId = section.id;
      if (section.id == 'cart-icon-bubble-new') {
        sectionId = 'cart-icon-bubble';
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[sectionId], section.selector);
      } else {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[sectionId], section.selector);
      }
    });

    this.checkGiftEligibility();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    console.log(selector);
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Gift Enforcement Logic
  checkGiftEligibility() {
    const cfg = document.getElementById('gift-config');
    if (!cfg) return;
    const giftProductId = parseInt(cfg.dataset.giftProductId || '0', 10);
    if (!giftProductId) return;

    const qualifyingVariantIds = (cfg.dataset.qualifyingVariants || '')
      .split(',')
      .map((s) => parseInt((s || '').trim(), 10))
      .filter((n) => !Number.isNaN(n) && n > 0);

    if (!qualifyingVariantIds.length) return;

    // Pull fresh cart JSON
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const hasQualifier = cart.items.some((it) => qualifyingVariantIds.includes(it.variant_id));
        const giftItems = cart.items.filter((it) => it.product_id === giftProductId);

        if (giftItems.length && !hasQualifier) {
          // Remove all gift variants
          const updates = {};
          giftItems.forEach((it) => {
            updates[it.variant_id] = 0;
          });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ updates }),
          })
            .then((r) => r.json())
            .then(() => this.refreshCartSections());
        }
      })
      .catch((e) => {
        console.warn('Gift eligibility check failed:', e);
      });
  }

  refreshCartSections() {
    const sectionsToRender = this.getSectionsToRender().map((s) => s.id).join(',');
    const baseCartUrl = (window.routes && window.routes.cart_url) || '/cart';
    const url = `${baseCartUrl}?sections=${encodeURIComponent(sectionsToRender)}`;

    fetch(url, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((sectionsHtml) => {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          const sectionId = section.id === 'cart-icon-bubble-new' ? 'cart-icon-bubble' : section.id;
          sectionElement.innerHTML = this.getSectionInnerHTML(
            sectionsHtml[sectionId],
            section.selector || '.shopify-section'
          );
        });

        // Rebind and reopen with the updated sections
        this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
        this.open();
      })
      .catch((e) => console.warn('Failed to refresh cart sections after gift removal:', e));
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);